import { HIGH_FIT_RANGE, MIDDLE_FIT_RANGE } from '.'

export const filter = (row, columnId, value) => {
  return value && value.length ? value.includes(row.getValue(columnId)) : true
}

export const filterStatus = (row, columnId, value) => {
  const { filterValue } = row.getValue(columnId).status
  return value && value.length ? value.includes(filterValue) : true
}

export const filterMore = (row, columnId, value) => {
  const filterValue = row.getValue(columnId)

  let rowCheckPassed = false

  value.forEach((filter) => {
    if (filterValue.includes(filter)) rowCheckPassed = true
  })

  return rowCheckPassed
}

export const filterScore = (row, columnId, value) => {
  let score = row.getValue(columnId)

  if (score === '-') score = '-'
  else if (HIGH_FIT_RANGE(score)) score = 'HIGH_FIT'
  else if (MIDDLE_FIT_RANGE(score)) score = 'MIDDLE_FIT'
  else score = 'LOW_FIT'

  return value && value.length ? value.includes(score) : true
}

export const filterAdditionalData = (row, columnId, value) => {
  const additionalData = row.getValue(columnId)
  if (!value || !value.length) return true

  try {
    const parsedData =
      typeof additionalData === 'string'
        ? JSON.parse(additionalData)
        : additionalData

    return value.some((filter) => {
      // Wenn der Filter keinen Doppelpunkt enthält, prüfen wir nur, ob das Feld existiert
      if (!filter.includes(':')) {
        return parsedData[filter] !== undefined
      }

      const [id, expectedValue] = filter.split(':')
      const field = parsedData[id]

      if (!field) return false

      // Wenn kein spezifischer Wert gefiltert wird, prüfen wir nur ob das Feld existiert
      if (!expectedValue) return true

      // Prüfe, ob es sich um ein Mehrfachauswahlfeld handelt
      if (field.multiple && Array.isArray(field.input)) {
        // Bei Mehrfachauswahl: Prüfe, ob einer der ausgewählten Werte dem Filter entspricht
        return field.input.some((item) => item.value === expectedValue)
      } else if (Array.isArray(field.input) && field.input.length > 0) {
        // Bei Einzelauswahl mit Array-Struktur: Prüfe den ersten Wert
        return field.input[0].value === expectedValue
      } else if (
        field.input &&
        typeof field.input === 'object' &&
        field.input.value
      ) {
        // Für einzelne Dropdown-Werte
        return field.input.value === expectedValue
      } else {
        // Fallback für andere Formate
        return field.input === expectedValue || field.value === expectedValue
      }
    })
  } catch (e) {
    // console.error('Fehler beim Filtern der zusätzlichen Daten:', e)
    return false
  }
}

export const decodeFilter = (item) => {
  const field = Object.keys(item)[0]
  const operator = Object.keys(item[field])[0]
  let value = Object.values(item[field])[0]

  if (operator === 'between') {
    value = `${value.min} - ${value.max}`
  }

  return { field, operator, value }
}

export const encodeFilter = (item) => {
  const field = item.field
  const operator = item.operator
  const value = item.value

  const result = {}
  result[field] = {}
  result[field][operator] = value

  return result
}
